import { apiClient } from "../../client"
import { PaginatedResponse } from "../role.repository"
import { City } from "./city.repository"




export interface District {
    id: number
    city_id: number
    en_name: string
    ar_name?: string | null
    status: number
    created_by?: number | null
    updated_by?: number | null
    created_at: Date
    updated_at: Date
    city: City
    ref_code?: string

}

export interface CreateDistrictRequest {
    city_id: number
    en_name: string
    ar_name?: string
    status?: number
    ref_code?: string

    // Note: created_by is automatically set by backend from logged-in user
}

export interface UpdateDistrictRequest {
    city_id?: number
    en_name?: string
    ar_name?: string
    status?: number
    ref_code?: string

    // Note: updated_by is automatically set by backend from logged-in user
}


class DistrictRepository {

    /**
       * Get all regions with pagination
       */
    async getAll(page: number = 1, limit: number = 10, filters?: any): Promise<PaginatedResponse<District>> {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        })

        // Add filters if provided
        if (filters) {
            if (filters.search) {
                params.append('search', filters.search)
            }
            if (filters.status) {
                params.append('status', filters.status)
            }
            if (filters.country_id) {
                params.append('city_id', filters.city_id)
            }
        }

        return apiClient.get<PaginatedResponse<District>>(`/districts?${params.toString()}`)
    }
    // 

    async getTotalDistricts() {
        return apiClient.get<any>('/districts/total-districts');
    }

    /**
       * Get region by ID
       */
    async getById(id: number): Promise<District> {
        return apiClient.get<District>(`/regions/${id}`)
    }

    /**
     * Create a new region
     */
    async create(data: CreateDistrictRequest): Promise<District> {
        return apiClient.post<District>('/districts', data)
    }

    /**
       * Update an existing region
       */
    async update(id: number, data: UpdateDistrictRequest): Promise<District> {
        return apiClient.put<District>(`/districts/${id}`, data)
    }

    /**
     * Delete a region
     */
    async delete(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/districts/${id}`)
    }

    /**
* Export regions to Excel
*/
    async exportToExcel(filters?: { search?: string; status?: string; city_id?: string }): Promise<Blob> {
        const params = new URLSearchParams()
        if (filters?.search) {
            params.append('search', filters.search)
        }
        if (filters?.status) {
            params.append('status', filters.status)
        }
        if (filters?.city_id) {
            params.append('city_id', filters.city_id)
        }

        const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:5000'
        const baseUrl = `${API_BASE_URL}/districts/export/excel`;
        const queryString = params.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        return apiClient.getBlob(url)
    }

}

export const districtRepository = new DistrictRepository();